/* Bodno cart v1.5 — Oct 27 2026 (v1.5, Eli: the quote form was bulky and promised a rep who never reached out: 3 fields (name, email, phone), posts to Bodno's quote system quiz-lead op cart_quote, which tags the quote "shopping cart - quote" + the rep, sends the rep's follow-up email and opens a HubSpot call task; the success message names the rep. v1.4: "Email me a quote" is live — it posts to the site-chat function, op cart_quote, which makes a real Shopify draft order and emails the quote with a copy to the rep; the form stays open through cart redraws. v1.3: cart tracking to Supabase site_cart_events; v1.2 Oct 13: kit, yearly, software edition; v1 live Oct 12). Renders the cart drawer from sections/cart-sidebar.liquid. */
(function () {
  if (window.BodnoCart) return;

  var QUOTE_URL = 'https://ekpavfdzsrfathpwjrwu.supabase.co/functions/v1/quiz-lead?op=cart_quote'; // v1.5 (was site-chat)
  var QSTATE = null; // v1.4: the quote form is open (and what was typed), kept across cart redraws
  var FREE = 10000;
  var CUTOFF_HOUR = 13; // 1 PM ET
  // Days the warehouse doesn't ship (YYYY-MM-DD, Eastern time). Add more as needed.
  var HOLIDAYS = ['2026-11-26', '2026-11-27', '2026-12-25', '2027-01-01', '2027-05-31', '2027-07-05', '2027-09-06', '2027-11-25', '2027-11-26', '2027-12-24'];

  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  // A/B: each visitor gets A or B once and keeps it.
  var AB = ls('bc_ab');
  if (AB !== 'A' && AB !== 'B') { AB = Math.random() < 0.5 ? 'A' : 'B'; ls('bc_ab', AB); }
  // Separate coin flips per test so the tests don't mix (Oct 12):
  //   swprice  A = software shown as $499.99 One-Time   B = shown as $13.89/mo (covers 3 years)  [Oct 12-15]
  //   swprice2 (Oct 15, Eli: a big monthly price reads like a subscription) A = $499.99 One-Time; B = $499.99 One-Time + small "works out to $13.89/mo over 3 years"
  //   swpos    A = software card last                    B = software card first
  function grp(k) { var g = ls(k); if (g !== 'A' && g !== 'B') { g = Math.random() < 0.5 ? 'A' : 'B'; ls(k, g); } return g; }
  //   swuser (Oct 15) the "one more license" offer on software lines: A = "Add another user"  B = "Add another computer" (lingo for existing customers)
  var SWP = grp('bc_t_swp'), SWPOS = grp('bc_t_swpos'), SWU = grp('bc_t_swu');
  var TESTS = 'swprice2:' + SWP + ',swpos:' + SWPOS + ',swuser:' + SWU;

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------- shipping / arrival line (Eastern time) ---------- */
  function etParts(d) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short' });
    var o = {};
    f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, min: +o.minute, wd: o.weekday };
  }
  function ymd(dt) { return dt.getUTCFullYear() + '-' + String(dt.getUTCMonth() + 1).padStart(2, '0') + '-' + String(dt.getUTCDate()).padStart(2, '0'); }
  function isBiz(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(ymd(dt)) === -1; }
  function addBiz(dt, n) { var x = new Date(dt.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isBiz(x)) n--; } return x; }
  function fmt(dt) { return dt.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }); }

  function shipText(total) {
    var p = etParts(new Date());
    var today = new Date(Date.UTC(p.y, p.m - 1, p.d));
    var shipDay, lead;
    if (isBiz(today) && p.h < CUTOFF_HOUR) {
      shipDay = today;
      var left = (CUTOFF_HOUR * 60) - (p.h * 60 + p.min);
      var hrs = Math.floor(left / 60), mins = left % 60;
      var t = (hrs ? hrs + ' hr ' : '') + mins + ' min';
      lead = 'Order in the next <b>' + t + '</b> and it ships today';
    } else {
      shipDay = addBiz(today, 1);
      var tomorrow = new Date(today.getTime()); tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
      var label = ymd(shipDay) === ymd(tomorrow) ? 'tomorrow morning' : shipDay.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'long' });
      lead = 'Order now and it ships ' + label;
    }
    var a = addBiz(shipDay, 1);
    var free = total >= FREE ? 'Free shipping · ' : '';
    return free + lead + '<span class="bc-arrive">Need it sooner? Overnight arrives <b>' + fmt(a) + '</b>. Choose it at checkout.</span>';
  }

  /* ---------- render ---------- */
  function root() { return document.querySelector('#cart-sidebar .bc'); }

  function contextUrl() {
    var ctx = ls('bc_ctx');
    if (location.pathname.indexOf('/products/') === 0) return location.pathname;
    if (ctx) return '/products/' + ctx;
    return '/';
  }

  function setup() {
    var r = root();
    if (!r) return;
    // v1.4: a redraw while the quote form is open keeps it open with what was typed
    if (QSTATE && QSTATE.open) {
      var qp = r.querySelector('[data-bc-quote-panel]');
      if (qp) {
        qp.hidden = false;
        var qf = qp.querySelector('[data-bc-quote-form]');
        if (qf) Object.keys(QSTATE.v || {}).forEach(function (k) { var inp = qf.elements[k]; if (!inp) return; if (inp.type === 'checkbox') inp.checked = !!QSTATE.v[k]; else inp.value = QSTATE.v[k]; });
      }
    }
    r.setAttribute('data-ab', AB);
    r.setAttribute('data-swp', SWP);
    r.setAttribute('data-swu', SWU);
    r.setAttribute('data-swpos', SWPOS === 'B' ? 'first' : 'last');
    // a freshly drawn cart starts the suggestion row at the first card (scroll-snap would otherwise
    // keep the old first card in view when the A/B card appears in front of it)
    if (!r.__bcInit) {
      r.__bcInit = true;
      r.querySelectorAll('[data-bc-recs]').forEach(function (x) { x.scrollLeft = 0; });
      requestAnimationFrame(function () { r.querySelectorAll('[data-bc-recs]').forEach(function (x) { x.scrollLeft = 0; }); });
    }
    var total = parseInt(r.getAttribute('data-total') || '0', 10);

    // remember the printer this visitor uses (cart or the product they're looking at)
    var src = r.getAttribute('data-ctx-source');
    var ctx = r.getAttribute('data-ctx');
    if (ctx && (src === 'cart' || src === 'page' || src === 'account')) ls('bc_ctx', ctx);

    var st = r.querySelector('[data-bc-ship-text]');
    if (st) st.innerHTML = shipText(total);

    // "ships your order free" tags on suggestions
    r.querySelectorAll('[data-bc-rec]').forEach(function (rec) {
      var btn = rec.querySelector('[data-bc-add]');
      var tag = rec.querySelector('[data-bc-free]');
      if (!btn || !tag) return;
      var price = parseInt(btn.getAttribute('data-price') || '0', 10);
      var ships = r.getAttribute('data-ships') === 'true';
      tag.hidden = !(ships && total < FREE && total + price >= FREE);
    });

    var cnt = r.getAttribute('data-count');
    document.querySelectorAll('.mini-cart span.cart-count, .summary span.cart-count, .cart-count-bubble span').forEach(function (el) { el.textContent = cnt; });
    var wrap = document.getElementById('cart-sidebar');
    if (wrap) {
      wrap.classList.toggle('is_empty', cnt === '0');
      wrap.classList.remove('_loading');
    }

    if (cnt === '0' && !r.getAttribute('data-customer')) localBuyAgain(r);

    // stamp the A/B group on the cart so every order carries it (the weekly report's denominator)
    if (cnt !== '0' && r.getAttribute('data-ab-saved') !== AB + '|' + TESTS) {
      r.setAttribute('data-ab-saved', AB + '|' + TESTS);
      post('/cart/update.js', { attributes: { _bc_ab: AB, _bc_tests: TESTS } }).catch(function () {});
    }
    // browser id on the order (Oct 14): an order placed days or weeks later links back to every earlier cart visit from this browser
    var vsv = trkVid();
    if (vsv && r.getAttribute('data-vid-saved') !== vsv && !r.__bcVid) {
      r.__bcVid = true;
      post('/cart/update.js', { attributes: { _bc_vid: vsv } }).catch(function () {});
    }
  }

  function render(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('.bc');
    var cur = root();
    if (fresh && cur) {
      var scroll = cur.scrollTop;
      cur.parentNode.replaceChild(fresh, cur);
      fresh.scrollTop = scroll;
    }
    setup();
  }

  // cart change + redrawn drawer in ONE request (Shopify bundled section rendering)
  var seq = 0;
  function mutate(url, body) {
    body.sections = 'cart-sidebar';
    body.sections_url = contextUrl();
    var mine = ++seq;
    return post(url, body).then(function (j) {
      var html = j && j.sections && j.sections['cart-sidebar'];
      if (mine !== seq) return j;
      if (html) { inflight = null; render(html); } else { return refresh(); }
      return j;
    });
  }

  var inflight = null;
  function refresh() {
    var url = contextUrl();
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    var req = fetch(url + sep + 'sections=cart-sidebar', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (req !== inflight) return;
        var html = json && json['cart-sidebar'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('.bc');
        var cur = root();
        if (fresh && cur) {
          var scroll = cur.scrollTop;
          cur.parentNode.replaceChild(fresh, cur);
          fresh.scrollTop = scroll;
        }
        setup();
      })
      .catch(function () {
        var wrap = document.getElementById('cart-sidebar');
        if (wrap) wrap.classList.remove('_loading');
      });
    inflight = req;
    return req;
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function showError(msg) {
    var r = root();
    var el = r && r.querySelector('.bc-error');
    if (el) { el.textContent = msg || 'Something went wrong. Please try again.'; el.style.display = 'block'; }
  }

  function tag(block) { return 'cart:' + block + ':' + AB; }

  /* ---------- buy again from this browser ---------- */
  function localBuyAgain(r) {
    var box = r.querySelector('[data-bc-local-buyagain]');
    var list = r.querySelector('[data-bc-local-list]');
    if (!box || !list) return;
    var last;
    try { last = JSON.parse(ls('bc_last') || 'null'); } catch (e) { last = null; }
    if (!last || !last.items || !last.items.length) return;
    var items = last.items.slice(0, 4);
    Promise.all(items.map(function (it) {
      return fetch('/products/' + it.handle + '.js').then(function (x) { return x.ok ? x.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var html = '';
      prods.forEach(function (p, i) {
        if (!p) return;
        var it = items[i];
        var v = (p.variants || []).filter(function (x) { return x.id === it.variant_id; })[0];
        if (!v || !v.available) return;
        var img = (it.image || p.featured_image || '').replace(/^http:/, 'https:');
        var title = (p.title || '').split(' for ')[0].replace('Bodno ', '');
        var sub = v.title && v.title !== 'Default Title' ? v.title : '';
        html += '<div class="bc-rec"><a class="bc-rec-img" href="/products/' + p.handle + '"><img src="' + img + '" alt="" width="120" height="120" loading="lazy"></a>' +
          '<div class="bc-rec-body"><span class="bc-rec-name">' + title + '</span>' + (sub ? '<span class="bc-rec-note">' + sub + '</span>' : '') + '</div>' +
          '<div class="bc-rec-side"><div class="bc-rec-price">' + money(v.price) + '</div><button type="button" class="bc-add bc-add--solid" data-bc-add data-variant="' + v.id + '" data-price="' + v.price + '" data-qty="' + (it.quantity || 1) + '" data-block="buyagain">Reorder</button></div></div>';
      });
      if (html) {
        list.innerHTML = html; box.hidden = false;
        // don't repeat a reorder item in "Supplies for your printer"
        list.querySelectorAll('[data-variant]').forEach(function (b) {
          r.querySelectorAll('[data-block="empty"][data-variant="' + b.getAttribute('data-variant') + '"]').forEach(function (d) {
            var row = d.closest('.bc-rec'); if (row) row.hidden = true;
          });
        });
      }
    });
  }

  /* ---------- events (bound once, delegated) ---------- */
  document.addEventListener('click', function (e) {
    var t;

    if ((t = e.target.closest('.bc-close'))) {
      e.preventDefault();
      document.querySelectorAll('.ajaxaddtocart-popup').forEach(function (p) { p.classList.remove('_show'); });
      document.querySelectorAll('.modal-backdrop').forEach(function (b) { b.remove(); });
      document.body.classList.remove('menu-open');
      return;
    }

    if ((t = e.target.closest('[data-bc-chip]'))) {
      e.preventDefault();
      var rec = t.closest('.bc-rec');
      rec.querySelectorAll('[data-bc-chip]').forEach(function (c) { c.classList.remove('is-on'); });
      t.classList.add('is-on');
      var add = rec.querySelector('[data-bc-add]');
      add.setAttribute('data-variant', t.getAttribute('data-variant'));
      add.setAttribute('data-price', t.getAttribute('data-price'));
      var pr = rec.querySelector('[data-bc-price]');
      if (pr) pr.textContent = money(parseInt(t.getAttribute('data-price'), 10));
      setup();
      return;
    }

    if ((t = e.target.closest('[data-bc-add]'))) {
      e.preventDefault();
      t.classList.add('is-busy');
      var blk = t.getAttribute('data-block') || 'add';
      var props = { _bc: blk === 'software' ? 'cart:software:price2-' + SWP + ':pos-' + SWPOS : tag(blk) };
      var tq = parseInt(t.getAttribute('data-qty') || '1', 10);
      track('offer_add', { block: blk, variant: parseInt(t.getAttribute('data-variant'), 10), qty: tq, price: parseInt(t.getAttribute('data-price') || '0', 10) * tq });
      t.setAttribute('data-label', t.textContent); t.textContent = 'Adding…';
      mutate('/cart/add.js', { items: [{ id: parseInt(t.getAttribute('data-variant'), 10), quantity: parseInt(t.getAttribute('data-qty') || '1', 10), properties: props }] })
        .catch(function (err) { t.classList.remove('is-busy'); t.textContent = t.getAttribute('data-label') || '+ Add'; showError(err && err.description); });
      return;
    }

    if ((t = e.target.closest('[data-bc-nudge]'))) {
      e.preventDefault();
      t.classList.add('is-busy');
      try { var n = JSON.parse(ls('bc_nudges') || '[]'); n.push({ ab: AB, at: Date.now() }); ls('bc_nudges', JSON.stringify(n.slice(-20))); } catch (x) {}
      var nkey = t.getAttribute('data-key'), nqty = parseInt(t.getAttribute('data-qty'), 10);
      // show it right away; the server confirms in the background
      var li = t.closest('.bc-item');
      var qin = li && li.querySelector('input.qty');
      if (qin) qin.value = nqty;
      var cta = t.querySelector('.bc-nudge-cta');
      if (cta) cta.textContent = '✓ Added';
      t.classList.add('is-done');
      var upd = {}; upd[nkey] = nqty;
      var rr = root();
      // remember "taken at this quantity" so the offer hides until the quantity changes again
      var nudged = (((rr && rr.getAttribute('data-nudged')) || ',') + t.getAttribute('data-variant') + '-' + nqty + ',').slice(-900);
      if (nudged.charAt(0) !== ',') nudged = ',' + nudged.slice(nudged.indexOf(',') + 1);
      var nIsUser = t.getAttribute('data-block') === 'user';
      track('offer_add', { block: nIsUser ? 'user' : 'nudge', variant: parseInt(t.getAttribute('data-variant'), 10), qty: 1, price: parseInt(t.getAttribute('data-price') || '0', 10) });
      mutate('/cart/update.js', { updates: upd, attributes: { _bc_nudge: nIsUser ? 'cart:user:' + SWU : 'cart:nudge:' + AB, _bc_nudged: nudged } })
        .catch(function (err) { t.classList.remove('is-busy', 'is-done'); showError(err && err.description); refresh(); });
      return;
    }

    if ((t = e.target.closest('[data-bc-swap]'))) {
      e.preventDefault();
      t.classList.add('is-busy');
      var p2 = {};
      try { p2 = JSON.parse(t.getAttribute('data-props') || '{}'); } catch (x) { p2 = {}; }
      if (Array.isArray(p2)) { var po = {}; p2.forEach(function (kv) { if (kv && kv.length === 2) po[kv[0]] = kv[1]; }); p2 = po; }
      var sblk = t.getAttribute('data-block') || 'lifetime';
      if (p2 && typeof p2 === 'object') { if (sblk === 'lifetime') { for (var pk in p2) { if (/^license$/i.test(pk) && typeof p2[pk] === 'string') p2[pk] = p2[pk].replace(/3-Year/i, 'Lifetime'); } } } else { p2 = {}; }
      // Oct 29 2026: term picker. Swapping to a plan-less term (One-Time, Lifetime) must not carry the subscription flag over
      if (!t.getAttribute('data-plan')) { for (var sk in p2) { if (/subscription/i.test(sk)) delete p2[sk]; } }
      p2._bc = tag(sblk);
      var key = t.getAttribute('data-key');
      var sli = { id: parseInt(t.getAttribute('data-variant'), 10), quantity: parseInt(t.getAttribute('data-qty') || '1', 10), properties: p2 };
      // subscriptions keep a plan: yearly swap uses the 12-month plan, edition swap keeps the current one
      var splan = parseInt(t.getAttribute('data-plan') || '', 10);
      if (splan) sli.selling_plan = splan;
      track('offer_add', { block: sblk, variant: sli.id, qty: sli.quantity, price: parseInt(t.getAttribute('data-price') || '0', 10) });
      post('/cart/add.js', { items: [sli] })
        .then(function () { return mutate('/cart/change.js', { id: key, quantity: 0 }); })
        .catch(function (err) { t.classList.remove('is-busy'); showError(err && err.description); refresh(); });
      return;
    }

    // ready-to-print kit: tap a tile to leave it out; the button total follows
    if ((t = e.target.closest('[data-bc-kt]'))) {
      e.preventDefault();
      t.classList.toggle('is-off');
      t.setAttribute('aria-pressed', t.classList.contains('is-off') ? 'false' : 'true');
      var kbox = t.closest('.bc-kit');
      var tiles = kbox.querySelectorAll('[data-bc-kt]');
      var kon = [], ksum = 0;
      for (var ki = 0; ki < tiles.length; ki++) {
        if (!tiles[ki].classList.contains('is-off')) { kon.push(tiles[ki].getAttribute('data-id') + ':1'); ksum += parseInt(tiles[ki].getAttribute('data-price') || '0', 10); }
      }
      var kbtn = kbox.querySelector('[data-bc-kit]');
      kbtn.setAttribute('data-items', kon.join(','));
      kbtn.disabled = !kon.length;
      kbtn.textContent = !kon.length ? 'Pick at least one item' : (kon.length === tiles.length ? 'Add all ' + kon.length : 'Add ' + kon.length) + ' · ' + money(ksum);
      return;
    }

    // ready-to-print kit: several items in one add
    if ((t = e.target.closest('[data-bc-kit]'))) {
      e.preventDefault();
      if (t.classList.contains('is-busy')) return;
      t.classList.add('is-busy');
      var kprops = { _bc: tag('kit') };
      var kitems = (t.getAttribute('data-items') || '').split(',').map(function (s) {
        var a = s.split(':'); return { id: parseInt(a[0], 10), quantity: parseInt(a[1] || '1', 10), properties: kprops };
      }).filter(function (x) { return x.id > 0; });
      t.setAttribute('data-label', t.textContent); t.textContent = 'Adding…';
      var kcents = 0;
      kitems.forEach(function (x) { var tile = t.closest('.bc-kit').querySelector('[data-bc-kt][data-id="' + x.id + '"]'); if (tile) kcents += parseInt(tile.getAttribute('data-price') || '0', 10); });
      track('offer_add', { block: 'kit', variant: kitems.length ? kitems[0].id : null, qty: kitems.length, price: kcents });
      mutate('/cart/add.js', { items: kitems })
        .catch(function (err) { t.classList.remove('is-busy'); t.textContent = t.getAttribute('data-label'); showError(err && err.description); });
      return;
    }

    if ((t = e.target.closest('[data-bc-scroll]'))) {
      e.preventDefault();
      var row = t.closest('.bc-setup').querySelector('[data-bc-recs]');
      if (row) row.scrollBy({ left: 160, behavior: 'smooth' });
      return;
    }

    if ((t = e.target.closest('[data-bc-checkout]'))) {
      track('checkout_click', { items: trkItems });
      flushTrack();
      fetch('/cart.js').then(function (x) { return x.json(); }).then(function (cart) {
        ls('bc_last', JSON.stringify({
          at: Date.now(),
          items: cart.items.filter(function (i) { return i.product_type !== 'Warranty' && i.requires_shipping; }).map(function (i) {
            return { variant_id: i.variant_id, handle: i.handle, image: i.image, quantity: i.quantity };
          })
        }));
      }).catch(function () {});
      return; // let the link go to checkout
    }

    if ((t = e.target.closest('[data-bc-quote-open]'))) {
      e.preventDefault();
      var panel = root().querySelector('[data-bc-quote-panel]');
      if (panel) { panel.hidden = false; root().scrollTop = 0; var f = panel.querySelector('input[name=fullname]'); if (f) f.focus(); }
      QSTATE = { open: true, v: (QSTATE && QSTATE.v) || {} };
      return;
    }
    if ((t = e.target.closest('[data-bc-quote-close]'))) {
      e.preventDefault();
      var panel2 = root().querySelector('[data-bc-quote-panel]');
      if (panel2) panel2.hidden = true;
      QSTATE = null;
      return;
    }
  });

  /* ---------- typed quantities (any number, e.g. 25 or 150) ---------- */
  function typedQty(inp) {
    if (!inp || !inp.closest('#cart-sidebar .bc')) return;
    var key = inp.getAttribute('data-id');
    var n = parseInt(inp.value, 10);
    if (isNaN(n) || n < 0) { refresh(); return; }
    if (String(n) === inp.getAttribute('data-last')) return;
    inp.setAttribute('data-last', String(n));
    var li = inp.closest('.bc-item');
    if (li) li.classList.add('is-busy');
    mutate('/cart/change.js', { id: key, quantity: n })
      .catch(function (err) { showError(err && err.description); refresh(); });
  }
  document.addEventListener('focusin', function (e) {
    var inp = e.target.closest && e.target.closest('#cart-sidebar input.qty');
    if (inp) { inp.setAttribute('data-last', inp.value); try { inp.select(); } catch (x) {} }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('#cart-sidebar input.qty');
    if (inp) typedQty(inp);
  });
  document.addEventListener('keydown', function (e) {
    var inp = e.target.closest && e.target.closest('#cart-sidebar input.qty');
    if (inp && e.key === 'Enter') { e.preventDefault(); inp.blur(); typedQty(inp); }
  });

  // v1.4: remember what's typed in the quote form, so a cart redraw doesn't wipe it
  document.addEventListener('input', function (e) {
    var qf = e.target.closest && e.target.closest('[data-bc-quote-form]');
    var bl = qf && e.target.closest('.bc-qf.is-bad'); if (bl) { bl.classList.remove('is-bad'); var be = bl.querySelector('.bc-qerr'); if (be) be.remove(); }
    if (!qf || !QSTATE) return;
    var t = e.target; if (t.name && t.name !== 'website') QSTATE.v[t.name] = t.type === 'checkbox' ? t.checked : t.value;
  });
  document.addEventListener('change', function (e) {
    var qf = e.target.closest && e.target.closest('[data-bc-quote-form]');
    if (!qf || !QSTATE) return;
    var t = e.target; if (t.name && t.type === 'checkbox') QSTATE.v[t.name] = t.checked;
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-bc-quote-form]');
    if (!form) return;
    e.preventDefault();
    var msg = form.querySelector('[data-bc-quote-msg]');
    var btn = form.querySelector('button[type=submit]');
    function say(text, ok) { msg.hidden = false; msg.className = 'bc-quote-msg ' + (ok ? 'is-ok' : 'is-err'); msg.innerHTML = text; }
    var el = form.elements;
    var data = {
      op: 'cart_quote', // kept in the body: snippets/bodno-ads-conv counts the Quote Sent conversion from it
      name: el.fullname.value.trim(),
      email: el.email.value.trim(),
      phone: el.phone.value.trim(),
      website: el.website.value,
      vid: trkVid() // browser id -> draft order attribute _bc_vid, so a paid quote links back to its cart visits
    };
    // v1.6 (Eli, Oct 27 5:03 PM: errors were too loud): mark each missing field quietly under the field, no box
    msg.hidden = true;
    var bad = [];
    function mark(inp, text) {
      var lab = inp.closest('.bc-qf'); if (!lab) return;
      var e = lab.querySelector('.bc-qerr');
      if (text) { lab.classList.add('is-bad'); if (!e) { e = document.createElement('em'); e.className = 'bc-qerr'; lab.appendChild(e); } e.textContent = text; bad.push(inp); }
      else { lab.classList.remove('is-bad'); if (e) e.remove(); }
    }
    mark(el.fullname, data.name ? '' : 'Enter your name');
    mark(el.email, /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(data.email) ? '' : (data.email ? 'Check the email address' : 'Enter your email'));
    mark(el.phone, data.phone.replace(/\D/g, '').length >= 10 ? '' : (data.phone ? 'Include the area code' : 'Enter your phone'));
    if (bad.length) { bad[0].focus(); return; }
    btn.disabled = true; btn.textContent = 'Sending…';
    fetch('/cart.js').then(function (x) { return x.json(); }).then(function (cart) {
      // v1.4: subscriptions, rentals and free lines are flagged so the server holds them for a person
      data.items = cart.items.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity, title: i.product_title, type: i.product_type, sub: !!i.selling_plan_allocation, price: i.final_line_price }; });
      data.page = location.href;
      // text/plain keeps it a simple request (no CORS preflight), like the chat widget
      return fetch(QUOTE_URL, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(data) });
    }).then(function (res) {
      return res.json().then(function (j) { if (!res.ok || !j.ok) throw j; return j; });
    }).then(function (j) {
      var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var rp = j.rep || {};
      say('<b class="bc-qok-h">Quote ' + (j.name ? esc(String(j.name).replace('#', '')) + ' ' : '') + 'sent</b>It\'s on its way to <b>' + esc(data.email) + '</b> with a PDF and a link to pay.' +
        (rp.name ? '<span class="bc-qok-rep"><b>' + esc(rp.name) + '</b>, your Bodno rep, will follow up' + (j.call ? ' by phone' : ' by email') + '. Questions now? <a href="tel:+17329875300">(732) 987-5300 ' + esc(rp.ext || '') + '</a></span>' : '') +
        (j.held && j.held.length ? '<span class="bc-qok-rep">' + esc(rp.first || 'Your rep') + ' will add these by hand: ' + j.held.map(esc).join(', ') + '.</span>' : ''), true);
      form.classList.add('is-sent');
      btn.textContent = 'Quote sent';
      QSTATE = null;
    }).catch(function (err) {
      btn.disabled = false; btn.textContent = 'Email me the quote';
      say((err && err.error) || 'We couldn\'t send the quote just now. Please email <a href="mailto:sales@bodno.com">sales@bodno.com</a> or call (732) 987-5300 and we\'ll send it right away.', false);
    });
  });

  setInterval(function () {
    var r = root();
    var st = r && r.querySelector('[data-bc-ship-text]');
    if (st) st.innerHTML = shipText(parseInt(r.getAttribute('data-total') || '0', 10));
  }, 60000);

  /* ---------- tracking (v1.3, Oct 14): every cart view (items + offers shown), offer adds, qty/remove, checkout clicks.
     Goes to BodnoHQ Supabase public.site_cart_events through log_cart_events() (origin-locked, insert-only).
     Anonymous: random browser id (bc_vid) + visit id (bc_sid, 30 min idle). Never blocks the cart if it fails. ---------- */
  var TRK_URL = 'https://ekpavfdzsrfathpwjrwu.supabase.co/rest/v1/rpc/log_cart_events';
  var TRK_KEY = 'sb_publishable_MYCNwkMx8vHKr5V8y3SMgw_GmCuhqMl';
  var trkQ = [], trkT = null, trkItems = null, trkOpen = false, trkSig = '';
  function trkId() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  function trkVid() { var v = ls('bc_vid'); if (!v) { v = trkId(); ls('bc_vid', v); } return v || 'nostore'; }
  function trkSid() {
    var s = null, now = Date.now();
    try { s = JSON.parse(window.sessionStorage.getItem('bc_sid') || 'null'); } catch (e) { s = null; }
    if (!s || !s.id || now - s.t > 1800000) s = { id: trkId(), t: now };
    s.t = now;
    try { window.sessionStorage.setItem('bc_sid', JSON.stringify(s)); } catch (e) {}
    return s.id;
  }
  function flushTrack() {
    if (!trkQ.length) return;
    var b = trkQ.splice(0, 40);
    try { fetch(TRK_URL, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', apikey: TRK_KEY }, body: JSON.stringify({ p: b }) }).catch(function () {}); } catch (e) {}
  }
  function track(ev, extra) {
    try {
      var r = root();
      var o = {
        vid: trkVid(), sid: trkSid(), ev: ev, ab: AB, tests: TESTS,
        page: (location.pathname || '').slice(0, 200), device: window.innerWidth < 768 ? 'phone' : 'desktop',
        customer: !!(r && r.getAttribute('data-customer')),
        customer_id: (r && r.getAttribute('data-cid')) || null,
        cart_total: r ? parseInt(r.getAttribute('data-total') || '0', 10) : null,
        cart_count: r ? parseInt(r.getAttribute('data-count') || '0', 10) : null,
        theme: ((window.Shopify && Shopify.theme && Shopify.theme.name) || '').slice(0, 80)
      };
      for (var k in extra) if (extra[k] !== undefined && extra[k] !== null) o[k] = extra[k];
      trkQ.push(o);
      clearTimeout(trkT);
      trkT = setTimeout(flushTrack, 1500);
    } catch (e) {}
  }
  function trkShown(r) {
    var seen = {}, out = [];
    r.querySelectorAll('.bc-addons [data-block], .bc-empty [data-block], [data-bc-nudge]').forEach(function (b) {
      if (!b.offsetParent) return; // hidden A/B copy or collapsed
      var k = b.hasAttribute('data-bc-nudge') ? (b.getAttribute('data-block') === 'user' ? 'user' : 'nudge') : b.getAttribute('data-block');
      if (k && !seen[k]) { seen[k] = 1; out.push(k); }
    });
    return out;
  }
  function trkView() {
    var r = root();
    if (!r) return;
    var blocks = trkShown(r);
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }).then(function (c) {
      trkItems = (c.items || []).slice(0, 30).map(function (i) {
        var o = { v: i.variant_id, q: i.quantity, p: i.final_line_price, t: i.product_type || '' };
        var bc = i.properties && i.properties._bc; // cart:<block>:<A|B> = added from a cart offer
        if (bc) o.b = String(bc).split(':')[1] || '';
        return o;
      });
      track('cart_view', { blocks: blocks, items: trkItems, cart_total: c.total_price, cart_count: c.item_count });
    }).catch(function () { track('cart_view', { blocks: blocks }); });
  }
  // a view = the drawer opening (class _show) or the /cart page; a changed cart while open counts as a new view
  setInterval(function () {
    var r = root();
    var open = !!(document.querySelector('#cart-sidebar .bc-popup._show') || document.querySelector('.bc-in-page #bc-root, #bc-root.bc-in-page, .bc-in-page .bc'));
    var sig = r ? (r.getAttribute('data-total') + '|' + r.getAttribute('data-count')) : '';
    if (open && (!trkOpen || sig !== trkSig)) { trkSig = sig; setTimeout(trkView, 400); }
    trkOpen = open;
  }, 1000);
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    // phone taps anywhere on the site (people who call for a quote / phone order after browsing)
    var tel = e.target.closest('a[href^="tel:"]');
    if (tel) { track('call_click', { block: e.target.closest('#cart-sidebar') ? 'cart' : 'site' }); flushTrack(); return; }
    if (!e.target.closest('#cart-sidebar')) return;
    var li = e.target.closest('.bc-item');
    var lv = li ? parseInt(String(li.getAttribute('data-id') || '').split(':')[0], 10) || null : null;
    var lb = null;
    if (lv && trkItems) trkItems.forEach(function (x) { if (x.v === lv && x.b) lb = x.b; });
    if (e.target.closest('.bc-remove')) track('remove', { variant: lv, block: lb });
    else if (e.target.closest('.qty-btn')) track('qty', { variant: lv, block: lb });
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('#cart-sidebar input.qty')) {
      var qv = parseInt(String(e.target.getAttribute('data-id') || '').split(':')[0], 10) || null, qb = null;
      if (qv && trkItems) trkItems.forEach(function (x) { if (x.v === qv && x.b) qb = x.b; });
      track(parseInt(e.target.value || '0', 10) === 0 ? 'remove' : 'qty', { variant: qv, block: qb, qty: parseInt(e.target.value || '0', 10) || 0 });
    }
  }, true);
  window.addEventListener('pagehide', flushTrack);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flushTrack(); });

  window.BodnoCart = { refresh: refresh, setup: setup, ab: AB, track: track };

  document.addEventListener('click', function (e) {
    if (e.target.closest('.open-shoppint-cart')) refresh();
  }, true);

  // the theme's own cart code (qty +/-, remove, product-page add to cart) uses jQuery; redraw after each change
  function hookJQ() {
    if (!window.jQuery || hookJQ.done) return;
    hookJQ.done = true;
    jQuery(document).ajaxComplete(function (ev, xhr, settings) {
      if (settings && /\/cart\/(add|change|update|clear)(\.js)?/.test(settings.url || '')) refresh();
    });
  }

  function boot() {
    hookJQ();
    // /cart page: show the same cart inside the page (sections/bodno-cart-page.liquid gives the slot)
    var slot = document.querySelector('[data-bc-page-slot]');
    var wrapEl = document.getElementById('cart-sidebar');
    if (slot && wrapEl) { slot.appendChild(wrapEl); wrapEl.classList.add('bc-in-page'); }
    // Whoever redraws the cart (us or the theme's old script), set the A/B groups before the browser paints
    if (wrapEl && window.MutationObserver) {
      new MutationObserver(function () {
        var r = root();
        if (r && (r.getAttribute('data-swp') !== SWP || r.getAttribute('data-ab') !== AB)) setup();
      }).observe(wrapEl, { childList: true, subtree: true });
    }
    // The theme's 5-year TotalCare pop-up after adding a printer stays on (Eli, Oct 12); the cart offer hides once TotalCare is in the cart.
    setup();
    var r = root();
    // the drawer that came with the page doesn't know the remembered printer yet
    if (r && ls('bc_ctx') && !r.getAttribute('data-ctx') && r.getAttribute('data-count') !== '0') refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();